"use strict";

function urlIsImage(url) {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}

export default urlIsImage;
